// Product labels use the compact action type and token corners. A restrained
// blue border/text distinguishes Studio from the neutral Enterprise lock label;
// brand-text supplies the readable blue for each theme.
export const StudioBadge = ({ label }: { label: string }) => (
  <span className="inline-flex h-5 shrink-0 items-center rounded border border-brand/40 bg-background px-2 font-jetbrains text-label uppercase text-brand-text">
    {label}
  </span>
)
